"use strict";
/* tslint:disable:max-line-length */
Object.defineProperty(exports, "__esModule", { value: true });
var string_serialiser_1 = require("./../serialisers/string-serialiser");
var service_definition_1 = require("./../services/service-definition");
var check_remote_server_result_serialiser_1 = require("./../services/remote-servers/check-remote-server-result-serialiser");
var create_remote_server_result_serialiser_1 = require("./../services/remote-servers/create-remote-server-result-serialiser");
var list_remote_servers_result_serialiser_1 = require("./../services/remote-servers/list-remote-servers-result-serialiser");
var remote_server_definition_serialiser_1 = require("./../services/remote-servers/remote-server-definition-serialiser");
exports.CREATE_REMOTE_SERVER = {
    id: 157,
    request: remote_server_definition_serialiser_1.RemoteServerDefinitionSerialiser,
    response: create_remote_server_result_serialiser_1.CreateRemoteServerResultSerialiser
};
exports.REMOVE_REMOTE_SERVER = {
    id: 158,
    request: string_serialiser_1.StringSerialiser,
    response: service_definition_1.NullSerialiser
};
exports.LIST_REMOTE_SERVERS = {
    id: 164,
    request: service_definition_1.NullSerialiser,
    response: list_remote_servers_result_serialiser_1.ListRemoteServersResultSerialiser
};
exports.CHECK_REMOTE_SERVER = {
    id: 165,
    request: string_serialiser_1.StringSerialiser,
    response: check_remote_server_result_serialiser_1.CheckRemoteServerResultSerialiser
};



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/remote-server-services.js
// module id = 1335
// module chunks = 1